import Swal from 'sweetalert2';

export function check_overflow() {
    function isElementOverflowing(element) {

        var overflowX = element.offsetWidth < element.scrollWidth,
            overflowY = element.offsetHeight < element.scrollHeight;
        console.log(overflowX + '+' + overflowY);
        return (overflowX || overflowY);
    }

    function wrapContentsInMarquee(element) {

        var marquee = document.createElement('marquee'),
            contents = element.innerText;

        marquee.innerText = contents;
        element.innerHTML = '';
        element.appendChild(marquee);
    }

    var element = document.getElementsByClassName('overmarquee');



    for (let i = 0; i < element.length; i++) {
        // element = element[i];
        console.log(element[i]);
        if (!element[i]) {
            break;

        }
        if (isElementOverflowing(element[i])) {
            wrapContentsInMarquee(element[i]);

        }


    }
}

//  short hand 
export var byId = function (id) { return document.getElementById(id); };







export const addDNoneClass = (htmlElement, status) => {
    if (status === true) {
        if(!htmlElement.classList.contains('d-none')){
            htmlElement.classList.add('d-none');
        }
       
    }
    if (status === false) {
        if(htmlElement.classList.contains('d-none')){
            htmlElement.classList.remove('d-none');
        }
       
    }

};



export function btnLoading(btn, msg, status) {

    if (!btn) {
        console.log('error in btn_loading');
    }

    const btn_id = btn.id;
    // console.log(btn_id);
    if (status === true) {
        btn.disabled = true;
        const old_data = btn.innerHTML;
        btn.innerHTML = `<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        ${msg}
        <span id='${btn_id + 'old_data'}' class='d-none'>${old_data}</span>`;
    }
    if (status === false) {
        btn.disabled = false;
        const old_data_div = byId(btn_id + 'old_data');
        const old_data = old_data_div.innerHTML;
        btn.innerHTML = `${old_data}`;
    }


}

export const Toast = Swal.mixin({
    toast: true,
    position: 'top',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer);
        toast.addEventListener('mouseleave', Swal.resumeTimer);
    }
});





export const unixTimeStampInSeconds = () => { return Math.floor(Date.now() / 1000); };


export const insertDataToElementUsingClassName = (className, data) => {
    // adding event listener for logout button
    const elements = document.getElementsByClassName(className);



    for (var i = 0; i < elements.length; i++) {
        elements[i].innerHTML = data;
    }
};

export const convertToTwoDecimalInt = (data) => { return +parseFloat(data).toFixed(2); };
export const convertToInt = (data) => { return +parseInt(data); };

export function capitalizeFirstLetter(string) {

    return string.charAt(0).toUpperCase() + string.slice(1);
}


export function generateUpiLink( amount) {
    // Encode the UPI ID, amount, and message as URL parameters
    const encodedUpiId = encodeURIComponent("7775814761@upi");
    const encodedAmount = encodeURIComponent(amount);
    const encodedMessage = encodeURIComponent(`buying ${amount} Credits in admin panel`);
  
    // Build the UPI link using the encoded parameters
    const upiLink = `upi://pay?pa=${encodedUpiId}&am=${encodedAmount}&tn=${encodedMessage}`;
  
    return upiLink;
}  